import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteApplicationFailed, deleteApplicationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deleteApplication(action) {
  try {
    const url = `${BACKEND_URL}/resources/applications/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteApplicationSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteApplicationFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteApplicationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
